import { WEB_ROUTES } from "../../shared/routes";

const publicNavPaths = [
  "/how-it-works",
  "/product",
  "/privacy-security",
  "/support",
  "/pricing"
] as const;

const publicNav = publicNavPaths.map((path) => {
  const route = WEB_ROUTES.find((candidate) => candidate.path === path);

  if (!route) {
    throw new Error(`Missing public navigation route: ${path}`);
  }

  return route;
});

interface SiteHeaderProps {
  readonly activePath: string;
}

export function SiteHeader({ activePath }: SiteHeaderProps) {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        <a className="brand-link" href="/">
          <span className="brand-dot" aria-hidden="true" />
          <span>Booply</span>
        </a>
        <nav aria-label="Primary" className="site-nav">
          <a aria-current={activePath === "/" ? "page" : undefined} href="/">Overview</a>
          {publicNav.map((route) => (
            <a
              aria-current={route.path === activePath ? "page" : undefined}
              href={route.path}
              key={route.path}
            >
              {navLabel(route.path, route.label)}
            </a>
          ))}
        </nav>
        <a className="nav-get" href="/download">Get Booply</a>
      </div>
    </header>
  );
}

function navLabel(path: string, fallback: string): string {
  switch (path) {
    case "/product":
      return "Spaces";
    case "/privacy-security":
      return "Privacy";
    case "/support":
      return "For your group";
    default:
      return fallback;
  }
}
